<template>
  <v-container>
    <view-intro heading="Миний xичээлүүд" />
    <v-row v-for="(semester,semindex) in semesters" :key="semindex">
      <h3>{{semester.name}} <span v-if="semester.lessons!=null">({{semester.lessons.length}})</span></h3>
      <teacher-lesson-table :lessons="semester.lessons"></teacher-lesson-table>
    </v-row>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import Vue from "vue";
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "MyLessons",
  components: {
    TeacherLessonTable: () => import("./TeacherLessonTable"),
  },
  data: () => ({
    schools: null,
    schoolId:"YJHjHWUGDok8teDhDIKX",
    semesters: null
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  computed: {},
  created() {
    this._setupp()
  },
  methods: {
    _setupp() {
      fb.db
        .collection('schools/'+ this.schoolId + '/semesters')
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          {
            this.semesters = [];
            querySnapshot.forEach((doc) => {
              console.log(doc.data());
              let semester = doc.data();
              semester.id = doc.id;
              semester.ref = doc.ref;
     
              // if (this.semesters.length == 1) {
              //   this._selectSchool(this.semesters[0]);
              // }
              semester.lessons = [];
              this.semesters.push(semester);
              fb.db.collection('schools/'+ this.schoolId + '/lessons')
              .onSnapshot((querySnapshot) => {
            
                  querySnapshot.forEach((doc) => {
                      let lesson = doc.data()
                      lesson.ref = doc.ref
                      lesson.id = doc.id
                      console.log(semester.ref.path==lesson.semester.path)
                      //if(lesson.semester.path==semester.ref.path) 
                      if(semester.ref.path==lesson.semester.path)
                        semester.lessons.push(lesson);
                  });
              });

            });
          }
        });
    },
    _goDetail(asuulga) {},
  },
};
</script>
<style>
#newelement {
  border-color: red;
}
</style>